import { render, staticRenderFns } from "./CoSimpleDropdownList.vue?vue&type=template&id=195272f2&scoped=true&"
import script from "./CoSimpleDropdownList.vue?vue&type=script&lang=ts&"
export * from "./CoSimpleDropdownList.vue?vue&type=script&lang=ts&"
import style0 from "./CoSimpleDropdownList.vue?vue&type=style&index=0&id=195272f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195272f2",
  null
  
)

export default component.exports